// LAMOUR — product Add-to-Cart behaviour. Loaded on ALL product templates (layout/theme.liquid).
//
// Merged 2026-08-04 from lamour-product-sticky-atc.js + lamour-product-hero-titlepanel.js, which
// duplicated each other's boilerplate (same guard, same scroll watching, same class-on-<html>
// pattern). Two jobs remain, and they are deliberately separate:
//
//   1. STICKY BAR CONFINEMENT — every product template.
//      Stock Prestige shows its sticky bar from the moment the buy form scrolls off the top until
//      the footer arrives (assets/theme.js, ProductStickyBar: `footerCondition && formCondition`),
//      so it hangs over related products and reviews. We hide it once the product section itself
//      leaves the viewport, keeping the bar to content about the product it belongs to.
//
//   2. HERO TITLE PANEL — huipil only, detected by the panel's presence in the DOM
//      (snippets/lamour-product-hero-titlepanel.liquid renders it only for that template suffix).
//      Fades the panel + its Add-to-Cart away once the visitor scrolls off the top of the page.
//
// FOUR classes on <html>, all read by assets/custom.css:
//
//   .lamour-atc-js                  this script's sticky half is running
//   .lamour-atc-visible             the product section is on screen
//   .lamour-js                      this script's hero half is running (⇒ also a huipil page)
//   .lamour-hero-titlepanel-visible the visitor is at the top of the page
//
// ⚠️ FAIL-SAFE CONTRACT. Every custom.css rule that HIDES part of the product page is gated on
// .lamour-atc-js or .lamour-js, so if this file fails to load or throws, the page degrades to
// stock Prestige with its title, price and Add to Cart intact — rather than to a page with no buy
// button. That is why each marker class is added AFTER the setup it vouches for, never before: a
// marker set ahead of code that then throws would switch the hiding rules on with nothing left
// running to switch them off again.
//
// Classes go on <html>, not on the elements themselves, because the sticky bar and the buy-buttons
// block both sit inside <product-rerender> and can be replaced wholesale on a variant change.

(function () {
  var section = document.querySelector('.shopify-section--main-product');
  if (!section) return;

  var root = document.documentElement;

  /* ---------- 1. Sticky bar confinement (all product templates) ---------- */

  new IntersectionObserver(function (entries) {
    root.classList.toggle('lamour-atc-visible', entries[0].isIntersecting);
  }, { threshold: 0 }).observe(section);

  root.classList.add('lamour-atc-js');

  /* ---------- 2. Hero title panel (huipil only) ---------- */

  if (!document.querySelector('.lamour-hero-titlepanel')) return;

  var HIDE_AFTER = 40; // px of scroll before the hero overlay clears away
  var ticking = false;
  var atc = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');

  function measureAtc() {
    root.style.setProperty('--lamour-hero-atc-height', atc.offsetHeight + 'px');
  }

  // The panel is positioned directly on top of the ATC, so its offset has to be measured —
  // CSS cannot read an element's height into a custom property.
  if (atc) {
    measureAtc();
    if ('ResizeObserver' in window) new ResizeObserver(measureAtc).observe(atc);
  }

  function update() {
    root.classList.toggle('lamour-hero-titlepanel-visible', window.scrollY < HIDE_AFTER);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  update();
  root.classList.add('lamour-js');
  window.addEventListener('scroll', onScroll, { passive: true });
})();
